import React from 'react'
import { useFormikContext } from 'formik'
import styled from 'styled-components'
import { CardHeader } from 'components'
import constants from 'constants/constants'
import Editor from 'features/forms/components/Editor'
import SelectField, { convertGroupedTags } from 'features/forms/components/SelectField'
import TextField from 'features/forms/components/TextField'
import {
    GetAttendeeTagsQuery,
    GetAttendeeTagsQueryVariables,
    GetInviteByIdQuery,
} from 'generated/graphql'
import { PickNode } from 'graphql/types'
import { useEventSlug, useQuery } from 'hooks'
import { _ } from 'utils'
import { attendeeTagsQuery } from '../graphql/query'

const S = {
    Header: styled(CardHeader)`
        display: flex;
        align-items: center;
        margin: 0 10px 20px 10px;
    `
}

const About = () => {
    const eventSlug = useEventSlug()
    const { values } = useFormikContext<PickNode<GetInviteByIdQuery, 'invites'>>()
    const freezeEmailField = values.status && values.status !== 'new'
    const { data } = useQuery<
        GetAttendeeTagsQuery, GetAttendeeTagsQueryVariables
    >(attendeeTagsQuery, { eventSlug })

    return (
        <>
            <S.Header>
                {_('attendee.form.personal_info_header')}
            </S.Header>
            <TextField
                name="firstName"
                label={_('attendee.form.first_name')}
                lg={1/2}
            />
            <TextField
                name="lastName"
                label={_('attendee.form.last_name')}
                lg={1/2}
            />
            <TextField
                name="email"
                label={_('attendee.form.email')}
                isRequired
                lg={1/2}
                isDisabled={freezeEmailField}
                helperText={freezeEmailField && _('attendee.form.freeze_email_helper_text')}
                showInfoIcon={freezeEmailField}
            />
            <TextField
                name="jobtitle"
                label={_('attendee.form.job_title')}
                lg={1/2}
            />
            <TextField
                name="company"
                label={_('attendee.form.company')}
                lg={1/2}
            />
            <SelectField
                name="tags"
                label={_('attendee.form.tags')}
                isMulti
                options={convertGroupedTags(data?.event?.userTags)}
                optionLabel="text"
                optionValue="id"
                lg={1/2}
            />
            <SelectField
                name="locationType"
                label={_('attendee.form.location_type')}
                options={constants.getLocationOptions()}
                lg={1/2}
            />
            <Editor
                name="about"
                label={_('attendee.form.about')}
            />
        </>
    )
}

export default About
